import { useEffect, useState } from 'react';
import { handleRequestHelper } from '../../../utils/helpers';
import api from '../../../api/api';
import { formatDatetime, formatPrice } from '../../../utils/utils';
import { CURRENCY } from '../../../constants/types';

export const useYearlyVolume = (producerId) => {
  const [yearlyVolume, setYearlyVolume] = useState(null);

  const getMetrics = async () => {
    await handleRequestHelper({
      endpoint: () => api.getYearlyVolume(producerId),
      onSuccess: ({ yearlyVolume }) => {
        const yearlyVolumeFormatted = formatPrice(
          yearlyVolume.total_amount,
          false,
          true,
          CURRENCY.ARS
        );
        const { day, dayOfWeek, month, year } = formatDatetime(yearlyVolume.start_date);
        setYearlyVolume({
          volume: yearlyVolumeFormatted,
          startDate: `${dayOfWeek}, ${day} de ${month} de ${year}`,
        });
      },
    });
  };

  useEffect(() => {
    getMetrics();
  }, []);

  return {
    yearlyVolume,
  };
};
